import { render, staticRenderFns } from "./OrderItemRowActions.vue?vue&type=template&id=4141c856"
import script from "./OrderItemRowActions.vue?vue&type=script&lang=js"
export * from "./OrderItemRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports